import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'cosmos-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class SectionComponent {
   @Input() public loading = false;
   @Input() public sectionTitle: string;
   @Input() public inheritHeight = true;
}
